import { FC, useContext, useEffect, useState } from 'react';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { GetPageProps, UserRegistrationState } from 'hooks/u002/useUserRegistrationHooks';
import { ConsentContent } from 'templates/ConsentContent';
import { PrivacyNoticeConsent as PrivacyNoticeConsentValue } from 'domains/User';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { Controller } from 'react-hook-form';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';
import { useGetAgreementText } from 'hooks/u002/useGetAgreementTextHooks';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';
import { AppContext } from 'templates/AppContextProvider';

//U002F03 プライバシーポリシー同意画面
type PrivacyNoticeConsentProps = GetPageProps<UserRegistrationState, 'PrivacyNoticeConsent'> & {
  audition: GetAuditionResponse & {
    audition_id: string;
    examination_no: number;
  };
};
export const PrivacyNoticeConsent: FC<PrivacyNoticeConsentProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const { userId, currentLang } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [privacyNoticeConsent, loading, err] = useGetAgreementText({
    user_id: userId,
    audition_id: props.audition.audition_id,
    examination_no: props.audition.examination_no,
    lang: currentLang,
    consent_type: '1', // 1: プライバシーポリシー
  });

  const handleBack = () => props.onBack();
  const handleNext = () => props.onNext();

  const { control } = props;

  const handleChange =
    (onChange: (value: PrivacyNoticeConsentValue) => void) => (checked: boolean) => {
      onChange(checked ? PrivacyNoticeConsentValue.Yes : PrivacyNoticeConsentValue.No);
    };

  useEffect(() => {
    if (err?.message) {
      setErrorMessage(tAuditionForm('TU002_050'));
    }
  }, [err]);

  return (
    <>
      {loading && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionForm('TU002_032')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <AppLogoHeader />
      <Controller
        control={control}
        name="privacy_notice_consent"
        render={({ field: { onChange, value } }) => {
          const checked = value === PrivacyNoticeConsentValue.Yes;
          return (
            <ConsentContent
              title={tAuditionForm('TU002_005')}
              text={privacyNoticeConsent?.consent_text}
              label={tAuditionForm('TU002_043')}
              nextLabel={tAuditionForm('TU002_044')}
              backLabel={tAuditionForm('TU002_045')}
              checked={checked}
              onChange={handleChange(onChange)}
              onBack={handleBack}
              onNext={handleNext}
            />
          );
        }}
      />
      <UnauthAppFooter />
    </>
  );
};
